import { searchCommonConfig } from './common'

/**
 * Novelarc 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
  },
}
